import {ModalContainerProps} from '@vw-marketing/us-components';
// import {FocusLayerSizeV2} from '@volkswagen-onehub/layer-manager';
import React from 'react';
import {useFeatureServices} from '../../hooks/use-feature-services';
import {ModalRedirectTranslations} from '../../typing/translations';
import {UsedVehicle} from '../../typing/used-inventory';
import ModalRenderContent from './modal-render-content';

interface ModalRedirectWithLayerProps extends ModalContainerProps {
  translations: ModalRedirectTranslations;
  vehicle?: UsedVehicle;
  urlRedirect?: string;
}

const ModalRedirectWithLayer: React.FC<ModalRedirectWithLayerProps> = (
  props,
) => {
  const {active, vehicle, translations, onCloseHandler, urlRedirect} = props;
  const layerManager = useFeatureServices()['layer-manager'];

  React.useEffect(() => {
    if (active) {
      layerManager.openContentLayerV2(
        ModalRenderContent,
        {
          text: 'redirect layer',
          index: 3,
          vehicle,
          translations,
          onCloseHandler,
          urlRedirect,
          canOpenInteraction: true,
          canOpenFocus: true,
          canOpenContent: true,
          canOpenFullscreenLayer: true,
        },
        {
          closeButtonLabel: '',
          contentHeadline: '',
          onClose: onCloseHandler,
        },
      );
    }

    return () => {};
  }, [active]);

  return <div>ModalRedirectWithLayer</div>;
};

export default ModalRedirectWithLayer;
